import { type ChartConfig } from '~/components/ui/shadcn/components/ui/chart';

export const chartConfig = {
  pageviews: {
    label: 'Pageviews',
    color: '#1488FC',
  },
  visitors: {
    label: 'Unique Visitors',
    color: '#1488FC',
  },
  bandwidth: {
    label: 'Bandwidth',
    color: '#1488FC',
  },
} satisfies ChartConfig;
